import type { PreviewViewV1 } from "@enrein/shared-contracts/approval-change";
import type { ClientPortalShellViewV1 } from "@enrein/shared-contracts/client-link";
import type { GreenfieldClientTabId } from "../types.js";
import { isIntakePhase } from "./intake-phase.js";

export function visibleClientTabs(input: {
  readonly shell: ClientPortalShellViewV1;
  readonly preview: PreviewViewV1 | null;
}): readonly GreenfieldClientTabId[] {
  const status = input.shell.state.status;

  if (isIntakePhase(status)) {
    return ["home", "intake", "requests", "help"];
  }

  const tabs: GreenfieldClientTabId[] = ["home"];
  const showPreview =
    input.preview != null ||
    ["PREVIEW_READY", "CHANGE_REQUESTED", "APPROVAL_PENDING", "APPROVED"].includes(status);
  const showReview = [
    "PREVIEW_READY",
    "CHANGE_REQUESTED",
    "APPROVAL_PENDING",
    "APPROVED",
    "PORTAL_ACTIVE",
    "SAFE_EDIT_ACTIVE",
    "HANDOFF_READY",
  ].includes(status);
  const showChanges = [
    "PREVIEW_READY",
    "CHANGE_REQUESTED",
    "APPROVAL_PENDING",
    "SAFE_EDIT_ACTIVE",
  ].includes(status);
  const showRecords = ["APPROVED", "HANDOFF_READY", "PORTAL_ACTIVE", "SAFE_EDIT_ACTIVE"].includes(status);

  if (showPreview) tabs.push("preview");
  if (showReview) tabs.push("review");
  if (showChanges) tabs.push("changes");
  tabs.push("requests");
  if (showRecords) tabs.push("records");
  tabs.push("help");
  return tabs;
}

export function defaultClientTab(input: {
  readonly shell: ClientPortalShellViewV1;
  readonly tabIds: readonly GreenfieldClientTabId[];
}): GreenfieldClientTabId {
  if (isIntakePhase(input.shell.state.status) && input.tabIds.includes("intake")) {
    return "intake";
  }
  return input.tabIds[0] ?? "home";
}

export function tabForJourneyIntent(intent: string | undefined): GreenfieldClientTabId | null {
  if (intent === "OPEN_CLIENT_INTAKE") return "intake";
  if (intent === "OPEN_CLIENT_CLARIFICATION") return "requests";
  if (intent === "OPEN_CLIENT_EXACT_PREVIEW" || intent === "OPEN_CLIENT_REVISED_PREVIEW") return "preview";
  if (intent === "GIVE_EXACT_APPROVAL") return "review";
  if (intent === "OPEN_OWNERSHIP_RECORDS") return "records";
  if (intent === "OPEN_SAFE_UPDATE") return "changes";
  return null;
}
